import React from 'react';
import { FlowerIcon } from 'lucide-react';
export function Divider() {
  return <div className="flex items-center justify-center gap-4 py-2" aria-hidden="true" data-id="element-12" data-mp="1gbigfj82hre9">
      <span className="h-px w-16 sm:w-24 bg-dorado/50" data-id="element-13" data-mp="1l2s4wghvqook" />
      <FlowerIcon className="h-5 w-5 text-dorado" strokeWidth={1.5} data-id="element-14" data-mp="1l3a7rvz1s15g" />
      <span className="h-px w-16 sm:w-24 bg-dorado/50" data-id="element-15" data-mp="1q0jw18apa6rp" />
    </div>;
}